module.exports = __webpack_public_path__ + "961cd5a22305417d5e24cf645928ae0e.pdf";